import React, { useContext, useState, useEffect, useRef } from "react";
import { Row, Col, Tooltip, Tabs, Button, Space, Table, Input, Popconfirm, Form, Select, message, DatePicker, Card, Popover } from "antd";
import { FormInstance } from 'antd/lib/form';
import BackNavigation from "../../../utils/Components/BackNavigation";
import "./applications.css";
import history from '../../../utils/history';
import { connect } from "react-redux";
import * as actions from "./actions";
import { InfoOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import moment from 'moment';
import ApplicationMaint from "./ApplicationMaint";
import { appConfigs } from "../../../utils/configurations";

const { Search } = Input;


interface Props{
    applicationsSetSearch: Function,
    applicationSetPagination: Function,
    getApplications: Function,
    openDrawer: Function,
    getAllApplicationsList: Function,
    getAllControllersList: Function,
    setTab: Function,
    context: any,
    applications: any,
    permissions: any,
    applicationsModification: any
}

const Applications: React.FC<Props> = (props) => {

    const drawerWidth: number = Math.min(window.innerWidth, appConfigs.settings.drawers.defaultWidth);
    const [selectedFilters, setSelectedFilters] = useState<any>({});

    const onTabChange = (key:string) => {
        props.setTab(key)
    }

    const { tableConfig, tableData } = props.applications.applicationsList;

    useEffect(() => {
        props.getAllApplicationsList()
        props.getAllControllersList(null, null, null, 1, 99999)
        props.applicationSetPagination(onPaginationChange(1));
    }, [])

    const renderApplicationsTable = (pagination: any, filters: any, sorter: any, extra: any, e:any) => {
        setSelectedFilters(filters)
        props.getApplications(null, null, null, pagination.current, props.applications.applicationsList.searchText, filters)
    }

    const onSearch = (searchText: string) => {   
        props.applicationsSetSearch((searchText || ""));

        if((searchText || "")==="") {
            history.push("/admin/applications");
        }
        
        setTimeout(function() {
            props.getApplications(null, null, null, 1, searchText, selectedFilters);   
        }, 100);      
    }

    const onSearchChange = (e: any) => {
        let value = e.target.value;
        props.applicationsSetSearch((value || ""));
    }

    const onPaginationChange = (page: number) => {
        props.getApplications(null, null, null, page, props.applications.applicationsList.searchText, selectedFilters);
    };

    const tableColumns = [
        {
            title: 'Application Name',
            dataIndex: 'name',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            render: (text: any, record: any) => (
                <span className="no-word-wrap">
                    <span >{record.type[0].toUpperCase() + record.type.slice(1)}</span>
                </span>  
            )
        },
        {
            title: "Version",
            dataIndex: "version",
        },
        {
            title: "Approval Required",
            dataIndex: "requiresApproval",
            render: (text: any, record: any) => (
                <span className="no-word-wrap">
                    <span >{record.requiresApproval[0].toUpperCase() + record.requiresApproval.slice(1)}</span>
                </span>  
            )
        },
        {
            title: "Compatible Controller",
            dataIndex: "controllerName",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        // {
        //     title: "Installations Count",
        //     dataIndex: "installationCount",
        // },
        {
            title: "Status",
            dataIndex: "status",
            filterMultiple: true,
            filteredValue: selectedFilters.hasOwnProperty('status') ? selectedFilters.status : [],
            filters: props.applications.applicationsList.columnsFilters.status?.map((status: any) => {
                return { 'value': status, 'text': status }
            }),
            render: (text: any, record: any) => (
                <span className="no-word-wrap">
                    <span >{record.status[0].toUpperCase() + record.status.slice(1)}</span>
                </span>  
            )
        },
        {
            title: "Actions",
            align: "center" as "center",
            render: (text: string, record: any) => (
                <Space>
                    {
                        <Tooltip title="View Application">
                            <Button
                                type="default" 
                                icon={<EditOutlined />}
                                onClick={(e) => { props.openDrawer(record.name, drawerWidth, record); }}
                            />
                        </Tooltip>
                    }                        
                </Space>
            )
        }
    ]


    return (

        <div className="layout-content">
            <Row gutter={8}>
                
                <Col xs={24} lg={14}>
                    <div className="content-header page-title">
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Go To Previous Page"> 
                                <BackNavigation /> 
                            </Tooltip>                            
                            {
                                <span>Applications Management</span>
                            }
                        </div>
                    </div>
                </Col>

            </Row>
            
            <div className="mt-15">
                <Row justify="end" gutter={24}>
                    
                    <Col xs={24} lg={24} className="content-header-controls">
                        <Space>
                            <Search
                                data-id="application-search-field"
                                key="search-field"
                                placeholder="Search By Name, Make, Model, Tags"
                                enterButton="Search"
                                size="middle"
                                allowClear
                                onSearch={onSearch}
                                onChange={onSearchChange}
                                className="search-field"
                                value={props.applications.applicationsList.searchText}
                            />

                            <Button data-id="applications-search-new-button" type="primary" icon={<PlusOutlined />} onClick={(e) =>  props.openDrawer("New Application", drawerWidth, {})}>
                                <span>Application</span>
                            </Button>
                        </Space>
                    </Col>

                    
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table 
                            data-id="applications-data" 
                            className="mt-15"
                            style={{ overflowX: 'auto' }} 
                            {...tableConfig}
                            rowKey={(record) => record.make+'-'+record.model+'-'+record.partNumber}
                            columns={tableColumns}
                            dataSource={tableData}
                            onChange={renderApplicationsTable}
                            showSorterTooltip={false}
                        />
                    </Col>       
                </Row>
                    
            </div>

            <ApplicationMaint/>
        </div>

    );

}

const mapStateToProps = (state:any) => {
    return {
        permissions: state.contextReducer.data,
        context: state.contextReducer.context,
        applications: state.applicationsReducers.applicationsState.applications,
        applicationsModification: state.applicationsReducers.applicationsState.applications.applicationsModification,
    };
};

export default connect(
    mapStateToProps,
    actions
)(Applications);
